import React from 'react'
import ArrowDown from '../../../../../assets/images/arrow-down.png'
import Selector from '../Selector'
import { toast } from 'react-toastify'

function MessageResivers({
  toogleDropdown,
  dropdown,
  selectedCustomer_types,
  setDropdown,
  setSelectedCustomer_types,
  customerTypes,
}) {
  const addTag = (customer_typesList) => {
    if (!selectedCustomer_types.includes(customer_typesList)) {
      setSelectedCustomer_types(selectedCustomer_types.concat(customer_typesList))
      setDropdown(false)
    } else {
      toast.warning('این دسته بندی قبلا اضافه شده')
    }
  }

  const removeTag = (customer_typesList) => {
    const filtered = selectedCustomer_types.filter((e) => e !== customer_typesList)
    setSelectedCustomer_types(filtered)
  }
  return (
    <div className="mt-12">
      <p className="text-main text-base mb-6 dark:text-gray-200">گیرنده پیامک را انتخاب کنید</p>
      <div className="autcomplete-wrapper">
        <div className="autcomplete">
          <div className="w-full flex flex-col items-center mx-auto">
            <div className="w-full">
              <div className="flex flex-col relative">
                <div className="w-4/12">
                  <div
                    className="my-2 p-1 flex flex-row-reverse border border-gray-200 dark:border-gray-700 bg-white dark:bg-slate-800 rounded-lg cursor-pointer"
                    onClick={toogleDropdown}
                  >
                    <div className="d-flex w-full justify-between content-between text-gray-300 py-1 pl-2 pr-1 flex dark:border-gray-700 dark:text-gray-200 dark:bg-slate-800">
                      <p className={'dark:text-gray-200'}>انتخاب دسته بندی</p>
                      <img
                        src={ArrowDown}
                        alt="reviewer"
                        className="dv-user-reviewer-icon w-5 h-5"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {dropdown ? (
                <Selector customer_types={customerTypes} addTag={addTag}></Selector>
              ) : null}
            </div>
          </div>
          <div className="mt-16">
            <p className="text-link my-2 dark:text-gray-200">
              {selectedCustomer_types?.length > 0 ? 'گیرنده پیامک ( دسته بندی)' : ''}
            </p>
            <div className="flex flex-wrap">
              {selectedCustomer_types.map((customer_typesList, index) => {
                return (
                  <div
                    key={index}
                    className="flex justify-center dark:bg-slate-800 dark:border-gray-700 items-center font-medium m-1 py-3 px-3 bg-light-blue rounded-lg border border-input-border w-68 h-16"
                  >
                    <div className="text-bold text-lg font-normal leading-none flex-initial dark:text-amber-50">
                      {customer_typesList?.value}
                    </div>
                    <div className="flex flex-auto flex-row-reverse">
                      <div onClick={() => removeTag(customer_typesList)}>
                        <span className="feather feather-x cursor-pointer text-red-500 hover:text-red-700 w-4 h-4 m-2">
                          حذف
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(MessageResivers)
